export const getStream = (str) => {
  const pos = str.lastIndexOf('/')
  return str.substr(pos + 1)
}
